import React, { Component } from 'react';
import { FormGroup } from '@blueprintjs/core';
import { ErrorMessage } from 'formik';
import ErrorWrapper from 'components/forms/components/error-wrapper';
import CreatableSelect from 'react-select/lib/Creatable';
import customStyles from 'utils/select-styles';

const createOption = label => ({
  label,
  value: label,
});

export default class FormCreatableGroup extends Component {
  state = {
    isLoading: false,
    options: [],
    value: undefined,
  };
  componentDidMount() {
    this.mapOptions();
    if (this.props.value) {
      this.mapValue();
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.asyncOptions !== this.props.asyncOptions) {
      this.mapOptions();
    }
    if (prevProps.value !== this.props.value) {
      this.mapValue();
    }
  }

  mapValue = () => {
    const { labelKey, valueKey, value } = this.props;
    if (value && value[labelKey] && value[valueKey]) {
      const mappedValue = {};
      Object.defineProperties(mappedValue, {
        label: {
          value: value[labelKey],
          writable: true,
        },
        value: {
          value: value[valueKey],
          writable: true,
        },
      });
      this.setState({ value: mappedValue });
    } else {
      this.setState({ value });
    }
  };

  mapOptions = () => {
    const { labelKey, valueKey, asyncOptions } = this.props;
    const options = asyncOptions.map(o => {
      const mappedPairs = {};
      Object.defineProperties(mappedPairs, {
        label: {
          value: o[labelKey],
          writable: true,
        },
        value: {
          value: o[valueKey].toString(),
          writable: true,
        },
      });
      return mappedPairs;
    });
    this.setState({ options });
  };
  handleChange = value => {
    this.props.onChange(this.props.name, value);
    if (this.props.name === 'vendorInformation') {
      if (value && !isNaN(value.value)) {
        this.props.fetchVendorProducts(value.value);
        this.props.fetchVendorContacts(value.label);
        //clearing vendor contacts when a new vendor is selected
        if (value !== this.state.value) {
          this.props.onChange('vendorContact', null);
          this.props.onChange('productServiceName', null);
        }
      } else {
        this.props.clearVendorProducts();
        this.props.clearVendorContacts();
      }
    }
  };
  handleCreate = inputValue => {
    const newOption = createOption(inputValue);
    this.handleChange(newOption);
  };

  handleBlur = () => {
    this.props.onBlur(this.props.name, true);
  };

  render() {
    const { isLoading, options, value } = this.state;
    return (
      <FormGroup
        inline={false}
        label={this.props.label}
        labelFor="select"
        className={this.props.class || ''}
        labelInfo={this.props.requiredLabel && '(required)'}
      >
        <CreatableSelect
          isClearable
          isDisabled={isLoading}
          isLoading={isLoading}
          onChange={this.handleChange}
          onCreateOption={this.handleCreate}
          onBlur={this.handleBlur}
          options={options}
          value={value}
          styles={customStyles}
          placeholder={this.props.placeholder}
          noOptionsMessage={() =>
            `No options available - start typing to create a new ${this.props.label}`
          }
        />
        <ErrorMessage
          name={this.props.name}
          render={msg => <ErrorWrapper>{msg}</ErrorWrapper>}
        />
      </FormGroup>
    );
  }
}
